import React from 'react';
import { capitalizeWords } from "../../utils/helpers";

const QuestionRenderer = ({ 
  question, 
  options, 
  responses, 
  onResponseChange 
}) => {
  return (
    <div className="assesment-cards mb-3">
      <div className="dashboard-title mb-3">
        <div className="font-smd fw-semibold">{question.question_text}</div>
      </div>
      <form>
        {question.question_type === "radio" && options[question.id] && options[question.id].length > 0 && (
          <>
            {options[question.id].map((option, i) => (
              <div key={i} className="xsm option-item d-flex align-items-center gap-2">
                <input
                  type="radio"
                  id={`option${question.id}-${i}`}
                  name={`question${question.id}`}
                  value={option.option_label}
                  checked={responses[question.id] === option.option_label}
                  className="form-check-input"
                  onChange={() => onResponseChange(question.id, option.option_label)}
                />
                <label htmlFor={`option${question.id}-${i}`} style={{ fontSize: '20px' }}>
                  {capitalizeWords(option.option_label)}
                </label>
              </div>
            ))}
          </>
        )}
        {question.question_type === "text_input" && (
          <input
            type="text"
            placeholder="Enter your answer"
            className="form-control"
            value={responses[question.id] || ''}
            onChange={(e) => onResponseChange(question.id, e.target.value)}
          />
        )}
      </form>
    </div>
  );
};

export default QuestionRenderer; 